export enum EmailTemplatesEnum {
  DEFAULT_TEMPLATE = 'website-default-template',
  AUTOMATION_TEMPLATE = 'website-automated-exam',
}
